export default {
  s3: {
    REGION: process.env.REACT_APP_REGION,
    BUCKET: process.env.REACT_APP_BUCKET_S3
  },
  apiGatewayUser: {
    REGION: process.env.REACT_APP_REGION,
    URL: process.env.REACT_APP_API_GATEWAY_USER_URL
  },
  apiGatewayDr: {
    REGION: process.env.REACT_APP_REGION,
    URL: process.env.REACT_APP_API_GATEWAY_DR_URL
  },
  cognito: {
    REGION: process.env.REACT_APP_REGION,
    USER_POOL_ID: process.env.REACT_APP_COGINITO_USER_POOL_ID,
    APP_CLIENT_ID: process.env.REACT_APP_COGINITO_CLIENT_ID,
    IDENTITY_POOL_ID: process.env.REACT_APP_COGINITO_IDENTITY_POOL_ID
  }
};
